import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "projects",
  initialState: {
    list: [],
    count: 0,
    selected: null,
    ipfs: [],
    images: [],
    count_images: 0,
    transactions: [],
    impacts: [],
    sdgs: [],
    blockchainTransactions: [],
  },
  reducers: {
    setProjects: (state, { payload: list }) => {
      return {
        ...state,
        list,
      };
    },
    countProjects: (state, { payload: count }) => {
      return {
        ...state,
        count,
      };
    },
    selectProject: (state, { payload: selected }) => {
      return {
        ...state,
        selected,
      };
    },
    deleteContact: (state, { payload: id }) => {
      return {
        ...state,
        list: [...state.list.filter((elem) => elem.id !== id)],
      };
    },
    setIpfs: (state, { payload: ipfs }) => {
      return {
        ...state,
        ipfs,
      };
    },
    setImages: (state, { payload }) => {
      const { resources = [], count = 0 } = payload || {};
      return {
        ...state,
        images: resources,
        count_images: count,
      };
    },
    setTransactions: (state, { payload: transactions }) => {
      return {
        ...state,
        transactions,
      };
    },
    countImages: (state, { payload: count_images }) => {
      return {
        ...state,
        count_images,
      };
    },
    setImpacts: (state, { payload: impacts }) => {
      return {
        ...state,
        impacts,
      };
    },
    setSdgs: (state, { payload: sdgs }) => {
      return {
        ...state,
        sdgs,
      };
    },
    setblockchainTransactions: (state, { payload: blockchainTransactions }) => {
      return {
        ...state,
        blockchainTransactions,
      };
    },
  },
});

export const {
  deleteContact,
  setProjects,
  countProjects,
  selectProject,
  setIpfs,
  setImages,
  countImages,
  setTransactions,
  setImpacts,
  setSdgs,
  setblockchainTransactions,
} = slice.actions;

export default slice.reducer;

export const getProjectsSelector = (store) => store.projects.list;
export const getProjectsCountSelector = (store) => store.projects.count;
export const getSelectedProjectSelector = (store) => store.projects.selected;
export const getIpfsSelector = (store) => store.projects.ipfs;
export const getTransactionsSelector = (store) => store.projects.transactions;
export const getcountImagesSelector = (store) => store.projects.count_images;
export const getImpactsSelector = (store) => store.projects.impacts;
export const getSdgsSelector = (store) => store.projects.sdgs;
export const getBlockchainTransactionsSelector = (store) =>
  store.projects.blockchainTransactions;
export const getImagesSelector = (store) => store.projects?.images || [];
export const getCountImagesSelector = (store) =>
  store.projects?.count_images || 0;
